import React, { useState, useEffect } from 'react';
import constants from '../../constants/constants';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { TabMenu } from 'primereact/tabmenu';
import { Calendar } from 'primereact/calendar';
import Comments from '../hodUser/Comments';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Controller, useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import axiosInstance from '../../constants/axiosInstance';
import { classNames } from 'primereact/utils';

const ProjectTask = ({sendDataToParent}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [remarks, setRemarks] = useState();
    const [records, setRecords] = useState();
    const statusList = ["In-Progress", "Completed"];
    const [isDisabled, setIsDisabled] = useState(false);
    const user = useStoreState((actions) => actions.loginModel.user);
    const projectViewDatas = useStoreState((actions) => actions.projectModel.projectViewDatas);
    const viewScreenHod = useStoreState((actions) => actions.projectModel.viewScreenHod);
    const setViewScreenHod = useStoreActions((actions) => actions.projectModel.setViewScreenHod);
    const toast = useRef(null);

    const header = (
        <div className="head-1">
            <h2 className="head-2">Task</h2>
        </div>
    );

    const setActiveIndex = useStoreActions((actions) => actions.tabModel.setActiveIndex);
    const activeIndex = useStoreState((actions) => actions.tabModel.activeIndex);

    const items = [
        { label: 'Comment' },
    ];

    useEffect(() => {
        setActiveIndex(0);
        getData();
    }, []);

    const getData = () => {
        axiosInstance.get(constants.APQP_UPL.PROJECTS + "/" + projectViewDatas?._id)
            .then((resp) => {
                // const comments = 
                const filteredSubTasks = [];
                resp?.data?.data?.forEach(project => {
                    project.taskHeader_id.forEach(header => {
                        header.subTasks.forEach(subTask => {
                            if (subTask._id === projectViewDatas?.subTaskId) {
                                filteredSubTasks.push(subTask);
                            }
                        });
                    });
                });
                setRecords(filteredSubTasks[0]);
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const defaultValues = { subTaskName: "", subTaskDescription: "", subTaskKeyPointers: "", assignTo: "", fileAttachment: "", startDate: "", endDate: "", subTaskRemarks: "", subTaskCriticality: "", subTaskActionPlan: "", completionDate: ""};
    const form = useForm({ defaultValues });
    const { reset, setValue } = form;
    const errors = form.formState.errors;
    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    useEffect(() => {
        if (projectViewDatas) {
            const allSubTasks = projectViewDatas?.taskHeader_id?.flatMap(header => header.subTasks || []);
            const selectedSubTask = allSubTasks?.find(
                (subTask) => subTask.subTaskName === projectViewDatas?.subTaskName
            );
            setValue("subTaskName", projectViewDatas?.subTaskName)
            setValue("subTaskDescription", projectViewDatas?.subTaskId?.subTaskDescription)
            setValue("subTaskStatus", projectViewDatas?.subTaskStatus ? projectViewDatas?.subTaskStatus : "Open")
            setValue("startDate", projectViewDatas?.subTaskStartDate ? new Date(projectViewDatas?.subTaskStartDate) : null)
            setValue("endDate", projectViewDatas?.subTaskEndDate ? new Date(projectViewDatas?.subTaskEndDate) : null)
            setValue("completionDate", projectViewDatas?.completedDate ? new Date(projectViewDatas?.completedDate) : null)
            setValue("fileAttachment", projectViewDatas?.fileAttachment === true ? "Yes" : "No")
            setValue("subTaskRemarks", projectViewDatas?.subTaskRemarks)
            if (selectedSubTask) {
                setValue("subTaskCriticality", selectedSubTask?.subTaskCriticality === "Accepted" ? "Yes"  : selectedSubTask?.subTaskCriticality === "Rejected"  ? "No" : selectedSubTask?.subTaskCriticality === "Acceptedwithderogation" ? "With derogation" : selectedSubTask?.subTaskCriticality
                )
            setValue("subTaskActionPlan", selectedSubTask?.subTaskActionPlan === "notChecked" ? "Not Checked" : selectedSubTask?.subTaskActionPlan)
            }
            setIsDisabled(projectViewDatas?.subTaskStatus === "Completed");
        }

    }, [projectViewDatas]);

    const onSubmitTask = (data) => {
        const payload = {
            subTaskStatus: data?.subTaskStatus,
            subTaskRemarks: data?.subTaskRemarks,
            completedDate: data?.subTaskStatus === "Completed" ? data?.completionDate || new Date() : null
        }
        setIsLoading(true);
        axiosInstance.patch(constants.APQP_UPL.PROJECTS + "/" + projectViewDatas?._id + "/taskHeader/" + projectViewDatas?.taskHeaderId + "/subtask/" + projectViewDatas?.subTaskId, payload)
            .then((resp) => {
                toast.current.show({ severity: "success", summary: "Success", detail: "Status Updated Successfully" });
                setIsDisabled(data?.subTaskStatus === "Completed");
                setViewScreenHod(false);
                sendDataToParent("Call"); 
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const inputRef = useRef(null);
    const handleFileUpload = (e, ids) => {
        const formData = new FormData();
        const files = e.target.files;

        for (let i = 0; i < files.length; i++) {
            formData.append('pdfFiles', files[i]);
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                "x-access-token": localStorage.getItem("access-token"),
                "x-access-time": new Date().toISOString()
            },
        };
        // setIsLoading(true);
        axiosInstance.post(constants.APQP_UPL.UPLOAD_ATTACHMENTS, formData, config)
            .then((resp) => {
                const uploadedPDF = resp?.data?.data?.map(item => { return { location: item.location, filename: item.originalname } })
                uploadAttachments(uploadedPDF, ids);
                // toast.current.show({ severity: "success", summary: "Success", detail: "Status Updated Successfully" });
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const uploadAttachments = (uploadedPDF, ids) => {
        const payload = {
            uploadAttachment: uploadedPDF
        }
        setIsLoading(true);
        axiosInstance.patch(constants.APQP_UPL.PROJECTS + "/" + ids?._id + "/taskHeader/" + ids?.taskHeaderId + "/subtask/" + ids?.subTaskId, payload)
            .then((resp) => {
                getData();
                toast.current.show({ severity: "success", summary: "Success", detail: "File Uploaded Successfully" });
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const deleteAttachments = (index, ids) => {
        setIsLoading(true);
        axiosInstance.delete(constants.APQP_UPL.PROJECTS + "/" + ids?._id + "/taskHeaders/" + ids?.taskHeaderId + "/subtasks/" + ids?.subTaskId + "/attachments/" + index)
            .then((resp) => {
                getData();
                toast.current.show({ severity: "success", summary: "Confirmed", detail: "Deleted Successfully", life: 3000 });
            }).catch((e) => {
                toast.current.show({ severity: "error", summary: "Failure", detail: e?.response?.data?.message });
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const confirm = (index, ids) => {
        confirmDialog({
            message: 'Do you want to delete this File?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => deleteAttachments(index, ids),
            // reject,
            acceptClassName: "btn-black",
            rejectClassName: "btn-yellow",
            draggable: false,
            // className: "confirm_dilog",
        });
    };

    // const taskCriticality = [
    //     { label: "Rejected", value: "Rejected" },
    //     { label: "Accepted with derogation", value: "Acceptedwithderogation" },
    //     { label: "Accepted", value: "Accepted" }
    //   ];
      const actionPlan = [
        { label: "Checked", value: "Checked" },
        { label: "Not Checked", value: "notChecked" }
      ];

    const [selectedTaskCriticality, setSelectedTaskCriticality] = useState("");

    return (
        <div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div>
                <div className="grid">
                    <div className="col-12">
                        <Card header={header}>
                            <form onSubmit={form.handleSubmit(onSubmitTask)} className="error_msg">
                                <div className="p-fluid formgrid grid">
                                    <div className='col-12 lg:col-6'>
                                        <div className="field col-12">
                                            <label htmlFor="subTaskName" className="col-6">
                                                Task Name
                                            </label><span className="w-full">
                                                <Controller name="subTaskName" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <InputText disabled id='subTaskName' value={field.value}/>
                                                    )}
                                                /></span>
                                        </div>
                                        <div className="field col-12">
                                            <label className="col-6" htmlFor="startDate">
                                                Start Date
                                            </label>
                                            <span className="w-full">
                                                <Controller name="startDate" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Calendar disabled dateFormat="dd/mm/yy" showIcon id={field.name} value={field.value} />
                                                    )}
                                                /></span>
                                        </div>
                                        <div className="field col-12">
                                            <label className="col-6" htmlFor="endDate">
                                                End Date
                                            </label>
                                            <span className="w-full">
                                                <Controller name="endDate" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Calendar disabled dateFormat="dd/mm/yy" showIcon id={field.name} value={field.value} />
                                                    )}
                                                /></span>
                                        </div>
                                        <div className="field col-12">
                                            <label className="col-6" htmlFor="subTaskCriticality" >
                                            Condition for transition
                                            </label>
                                            <span className="w-full">
                                                <Controller
                                                    name="subTaskCriticality"
                                                    control={form.control}
                                                    // rules={{ required: "Task Criticality is required" }}
                                                    render={({ field, fieldState }) => (
                                                        <InputText disabled id='subTaskCriticality' value={field.value}/>
                                                        // <Dropdown  value={field.value} placeholder=""
                                                        // onChange={(e) => {field.onChange(e.target.value); setSelectedTaskCriticality(e.target.value);}} />
                                                    )}
                                                />
                                                </span>
                                        </div>
                                        {form.watch("subTaskActionPlan") && (
                                        <div className="field col-12">
                                            <label className="col-6" htmlFor="subTaskActionPlan" >
                                             Action Plan
                                            </label>
                                            <span className="w-full">
                                                <Controller
                                                    name="subTaskActionPlan"
                                                    control={form.control}
                                                    // rules={{ required: "Task Criticality is required" }}
                                                    render={({ field, fieldState }) => (
                                                        // <Dropdown  options={actionPlan}  value={field.value} placeholder=""
                                                        //  onChange={(e) => {field.onChange(e.target.value)}} />
                                                        <InputText disabled id='actionPlan' value={field.value}/>
                                                        )}
                                                />
                                                </span>
                                        </div>
                                         )} 
                                         <div className="field col-12">
                                            <label className="col-6" htmlFor="completionDate">
                                                Completion Date
                                            </label>
                                            <span className="w-full">
                                                <Controller name="completionDate" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <Calendar showIcon id={field.name} dateFormat="dd/mm/yy" value={field.value} onChange={(e) => { field.onChange(e.value);}} />
                                                    )}
                                                /></span>
                                        </div>
                                       
                                    </div>
                                    <div className='col-12 lg:col-6'>
                                        <div className="field col-12 align-items-start">
                                            <label htmlFor="subTaskDescription" className="col-6 mt-3">
                                                Task Description
                                            </label><span className="w-full">
                                                <Controller name="subTaskDescription" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <InputTextarea disabled readOnly rows={3} id='subTaskDescription' value={field.value} />
                                                    )}
                                                /></span>
                                        </div>
                                        <div className="field col-12">
                                            <label htmlFor="subTaskRemarks" className="col-6">
                                                Comments
                                            </label><span className="w-full">
                                                <Controller name="subTaskRemarks" control={form.control}
                                                    render={({ field, fieldState }) => (
                                                        <InputText id='subTaskRemarks' value={field.value} onChange={(e) => field.onChange(e.target.value)} />
                                                    )}
                                                />
                                                {getFormErrorMessage("subTaskRemarks")}</span>
                                        </div>
                                        <div className="field col-12">
                                            <label htmlFor="subTaskStatus" className="col-6">
                                                Status
                                            </label><span className="w-full">
                                                <Controller name="subTaskStatus" control={form.control}
                                                    rules={{ required: "Status is required" }}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown options={statusList} value={field.value} id='subTaskStatus'
                                                            onChange={(e) => field.onChange(e.target.value)} />
                                                    )}
                                                />
                                                {getFormErrorMessage("subTaskStatus")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-content-end">
                                    <Button size="small" loading={isLoading} label="Save" className="btn-yellow" />
                                </div>
                            </form>
                            <Divider />
                            {records && records?.fileAttachment ? 
                            <div className='text-center'>
                            <div className='flex justify-content-between text-center align-items-center'>
                                <div className='user-attachment'>Attachment</div>
                                <div className='flex align-items-center text center mt-3' onClick={() => inputRef.current.click()}>
                                <div className='file-upload-size'>Maximum File Size: 20MB <span className='ml-2'>Supported Format: JPG, PNG, PDF, XLSX</span></div><label className="btn-black-user align-items-center text center flex mx-2">Upload</label>
                                    <span className="">
                                        <input multiple className='inbox' onChange={(e) => handleFileUpload(e, projectViewDatas)} placeholder="Enter Document Name" accept=".pdf, .xlsx, .png, .jpg" ref={inputRef} type="file" style={{ display: "none" }} required />
                                        {/* <i className="pi pi-upload ml-3" /> */}
                                    </span>
                                </div>
                            </div>
                            <Divider />
                            {records && records?.uploadAttachment?.map((item, index) => {
                                return (
                                    <div className='flex justify-content-between text-center' style={{marginBottom:'15px'}}>
                                       <div> <a href={item?.location} target='_blank' className='inline-block upload-text'>{item?.filename}</a> </div>
                                       <div> <i className='pi pi-trash' onClick={() => confirm(index, projectViewDatas)} style={{color:'#03030A'}}></i> </div>
                                    </div>
                                )
                            })}
                            </div> : null }
                            <div className="title1 cursor-pointer mt-4">
                                <span className="user-attachment">Chat Activity</span>
                            </div>
                            <hr className="hr-line my-4"></hr>
                            {/* <div className="flex justify-content-between master-tab-inner">
                                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                            </div> */}
                            {/* {activeIndex === 0 && <div></div>} */}
                            {activeIndex === 0 && <div><Comments /></div>}
                            {/* {activeIndex === 1 && <div></div>} */}
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectTask